import { Guid } from "./Guid";

export class LeadTimeRule {
  public constructor() {
    this.RuleID = Guid.newGuid();
  }

  public RuleID: string;

  public RuleTest: string;

  public LeadTimeDays: number;

  public CustomMessage: string;

  public ExpirationDate: Date;

  public CreatedBy: string;

  public CreateDate: Date;

  public RecordDate: Date;

  public UpdatedBy: string;

  public Deleted: boolean;
}
